<template>
  <div>
    <table>
      <thead>
        <tr>
          <th>
            <v-tooltip top>
              <template v-slot:activator="{ on, attrs }">
                <v-btn
                  color="primary"
                  @click="see = !see"
                  v-bind="attrs"
                  v-on="on"
                  rounded
                  outlined
                  x-small
                >
                  <v-icon small>{{
                    see ? "mdi-eye-off" : "mdi-eye"
                  }}</v-icon></v-btn
                >
              </template>
              <span>{{ see ? "Parar de v" : "V" }}er valores</span>
            </v-tooltip>
          </th>
          <th v-for="(header, i) in colHeader" :key="i">
            {{ header }}
          </th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="(row, i) in matrix" :key="i">
          <template v-if="i < 16">
            <td class="line">{{ rowHeader[i] }}</td>
            <td
              v-for="(_item, j) in row"
              @click.stop="clickItem(i, j)"
              :key="j"
              :class="
                `item ${
                  item[0] == i && item[1] == j ? 'clicked' : ''
                }`
              "
              :style="{
                backgroundColor: calculateColor(_item)
              }"
            >
              <span v-if="see" class="value">{{
                calculate_value(_item)
              }}</span>
            </td>
          </template>
        </tr>
      </tbody>
    </table>
  </div>
</template>

<script>
export default {
  name: "HandleMatrix",
  props: {
    matrix: Array,
    rowHeader: Array,
    colHeader: Array,
    item: Array,
    max: Number,
    option_max: Number,
    showValuesByDefault: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      see: this.showValuesByDefault
    };
  },
  watch: {
    see(novoValor) {
      this.$emit("see-changed", novoValor);
    }
  },
  methods: {
    clickItem(i, j) {
      this.$emit("click-item", i, j);
    },
    calculate_value(value) {
      switch (this.option_max) {
        case 1: {
          let classes = Math.round(value * this.max);
          return classes === 0 ? "" : `${classes}`;
        }

        default: {
          let available = this.max - Math.round(value * this.max);
          return available === this.max ? "" : `${available}`;
        }
      }
    },
    calculateColor(index) {
      const startColor = [245, 245, 245]; // rgba(245,245,245,1)
      const endColor = [7, 87, 199]; // rgba(7,87,199,1)

      // Adjust index to create an exponential gradient
      const adjustedIndex = Math.pow(index, 2); // Quadratic adjustment for higher variability

      const r =
        startColor[0] + (endColor[0] - startColor[0]) * adjustedIndex;
      const g =
        startColor[1] + (endColor[1] - startColor[1]) * adjustedIndex;
      const b =
        startColor[2] + (endColor[2] - startColor[2]) * adjustedIndex;

      return `rgb(${Math.round(r)},${Math.round(g)},${Math.round(
        b
      )})`;
    }
  }
};
</script>

<style scoped>
.item,
.line {
  border: solid 4px white;
  margin: 0 2px 2px 0;
}

.item {
  cursor: pointer;
}

.clicked {
  -webkit-box-shadow: inset 0px 0px 0px 10px white;
  -moz-box-shadow: inset 0px 0px 0px 10px white;
  box-shadow: inset 0px 0px 0px 10px white;
}

.line {
  background-color: #f5f5f5;
}

table {
  width: 100%;
  border-collapse: collapse;
}

th,
td {
  text-align: center;
  padding: 8px;
}

.value {
  background-color: #f5f5f5;
  color: #0088ff;
  font-size: small;
  font-weight: bold;
  padding: 2px 6px;
  border-radius: 20px;
}
</style>
